import {
  errorStatus,
  fictitiousStatus,
  occupationStatus,
  paidStatus,
  unconfirmedStatus,
} from 'modules/accommodations/features/reservations/consts';
import { colors } from 'services/theme/constants';

export const chipColor = (status: string): { borderColor: string; bgColor: string } => {
  if (errorStatus.includes(status)) {
    return { borderColor: colors.negative_dark, bgColor: colors.negative_10 };
  } else if (unconfirmedStatus.includes(status)) {
    return { borderColor: colors.warning_dark, bgColor: colors.warning_10 };
  } else if (paidStatus.includes(status)) {
    return { borderColor: colors.green_90, bgColor: colors.green_10 };
  } else if (occupationStatus.includes(status)) {
    return { borderColor: colors.black_80, bgColor: colors.black_5 };
  } else {
    return { borderColor: colors.purple, bgColor: colors.purple_25 };
  }
};
